<button
  #trigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  mat-icon-button
  matTooltip="Hide or Show Columns"
  type="button"
  (click)="$event.stopPropagation(); toggleFilter()"
>
  <mat-icon>view_column</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="showFilter"
  [cdkConnectedOverlayPanelClass]="'ag-table-column-panel'"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="toggleFilter(); this.createColumns(tableGridColumns)"
>
  <mat-card>
    <div [formGroup]="form">
      <mat-form-field>
        <input
          agAutofocus
          type="text"
          matInput
          formControlName="filter"
          appearance="flat"
          autocomplete="off"
          [placeholder]="placeholder"
          (keyup)="filter($event)"
        />
        <button
          *ngIf="form.get('filter').value.length; else showSearchIcon"
          mat-icon-button
          matSuffix
          type="button"
          (click)="clear()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <ng-template #showSearchIcon>
          <button mat-icon-button matSuffix disabled type="button">
            <mat-icon>search</mat-icon>
          </button>
        </ng-template>
      </mat-form-field>

      <mat-card-content>
        <mat-selection-list>
          <mat-list-option
            *ngFor="let item of filteredColumns"
            [value]="item.value"
            [selected]="item.display"
            (click)="toggleDisplayedColumn(item)"
          >
            {{ item.label }}
          </mat-list-option>
        </mat-selection-list>
      </mat-card-content>
    </div>
  </mat-card>
</ng-template>
